<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import StatementEdit from "$app/Pages/Plans/OnePageView/StatementEdit.svelte"
  import { Plus } from "lucide-svelte"
  import emptyImg from "@images/onboarding/empty.png"
  import { STATEMENT_SECTIONS } from "$app/constants"
  import { appStore } from "$app/store.svelte"

  interface Props {
    editable: boolean
    title?: string
    statements: StatementType[]
    sectionType: StatementSectionType
    icon: string
    height?: string
    actionCable?: boolean
  }

  let {
    editable,
    title = "",
    statements,
    sectionType,
    icon,
    height = "h-72",
    actionCable = false
  }: Props = $props()

  const sect = STATEMENT_SECTIONS[sectionType]

  let editStatus = $state("")
  let openEditModal = $state(false)
  let showDetailModal = $state(false)

  let openModalConfirm = $state(false)

  const onUpdate = (data: StatementType[]) => {
    if (!actionCable) {
      appStore.updateStatements(data, sectionType)
    }
  }
</script>

<div class="relative bg-white p-2 {height}">
  {@html icon}

  <div class="px-4 py-4 sm:px-6">
    <div class="w-full">
      <h3 class="leading-6 font-bold text-black text-center">{title}</h3>
    </div>
  </div>

  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <div
    class="p-2 text-center cursor-pointer"
    onclick={() => (showDetailModal = true)}
    role="button"
    tabindex="0"
  >
    {#each statements.slice(0, 3) as statement}
      <div class="text-sm mb-2">
        {statement.name}
      </div>
    {:else}
      <div class="flex flex-col justify-center items-center">
        <img src={emptyImg} class="w-16 h-auto" alt="No Brand Purpose" />
        <button
          class="mt-6 border py-2 px-4 rounded flex hover:bg-gray-100 text-gray-800 items-center justify-center"
          type="button"
          onclick={() => {
            editStatus = "new"
            appStore.trackStatement.status === "edit"
            openEditModal = true
          }}
        >
          <Plus class="text-gray-600" />
          <div class="text-center text-sm ml-1">Create your {sect.name}</div>
        </button>
      </div>
    {/each}
  </div>

  {#if editable}
    <div class="w-12 absolute top-2 right-2">
      <button
        type="button"
        class="btn-link"
        data-name="edit-brand-purpose"
        onclick={() => {
          appStore.trackStatement.status = "edit"
          openEditModal = true
        }}
      >
        EDIT
      </button>
    </div>
  {/if}
</div>

<!--Show detail-->
<Modal bind:open={showDetailModal}>
  <div class="flex flex-col px-8 my-4 min-w-2xl max-w-3xl">
    <h3 class="py-3 text-2xl font-bold text-center">{sect.plural}</h3>
    <div
      class="grid grid-cols-1 sm:grid-cols-3 gap-4 border-b border-gray-100 py-4"
    >
      {#each statements.slice(0, 3) as statement}
        <div><h3 class="text-lg font-bold">{statement.name}</h3></div>
        <div class="col-span-2">
          <div class="ProseMirror">
            <p>
              {@html statement.description || ""}
            </p>
          </div>
        </div>
      {/each}
    </div>
  </div>
</Modal>

<!--Edit-->
<Modal
  bind:open={openEditModal}
  large={true}
  onclose={() => {
    if (
      appStore.trackStatement.edited &&
      appStore.trackStatement.status === "edit"
    ) {
      openModalConfirm = true
    }
  }}
>
  <StatementEdit
    section={sectionType}
    initialStatus={editStatus}
    symbolPicker={false}
    onupdate={onUpdate}
  />
</Modal>

<Modal
  bind:open={openModalConfirm}
  closeButton={false}
  style="max-width: 400px !important;"
>
  <div>
    <div class="py-4">
      You have unsaved changes, are you sure you want to leave?
    </div>

    <div class="flex gap-4">
      <button
        class="btn primary"
        onclick={() => {
          openModalConfirm = false
          openEditModal = true
        }}
      >
        No
      </button>
      <button
        class="btn secondary"
        onclick={() => {
          openModalConfirm = false
          openEditModal = false
          appStore.trackStatement.edited = false
        }}
      >
        Yes, Close
      </button>
    </div>
  </div>
</Modal>
